import React, { Component } from 'react'

import PropTypes from 'prop-types'

import * as spaceman from '../../../../assets/spacemanShutterStock.jpg'
import InfoButton from '../../../../components/ui/buttons/InfoButton'
import numberConverter from '../../../../utils/tuition/numberForCurrency'

export default class BreakevenAnalysis extends Component {
  static propTypes = {
    data: PropTypes.any,
  }

  static defaultProps = {
    data: {},
  }

  render() {
    const {
      data: { breakeven_year },
      salaryWithDegree,
      salaryWithoutDegree,
    } = this.props

    return (
      <div className="row" style={{ marginTop: 10 }}>
        <div className="col-md-12">
          {breakeven_year ? (
            <h5>
              Judging by your debt and expected salary, it will take{' '}
              <strong style={{ textDecoration: 'underline' }}>
                {breakeven_year} years
              </strong>{' '}
              to breakeven on your education investment.
            </h5>
          ) : (
            <h5>
              It looks like you will not breakeven during your investment period
            </h5>
          )}
        </div>

        <div className="col-lg-8">
          <table className="table table-striped text-center">
            <tbody>
              <tr>
                <td>Breakeven Year:</td>
                <td
                  style={{ fontFamily: 'muli', fontSize: 20, fontWeight: 800 }}
                >
                  &nbsp;&nbsp;{breakeven_year}&nbsp;
                  <InfoButton
                    content={`After year ${breakeven_year}, the extra money you made with your degree will be higher the total cost of your loans.`}
                    styles={{ fontSize: 14 }}
                    iconClass="fal fa-calendar-alt"
                  />
                </td>
              </tr>
              <tr>
                <td>Salary with Degree:</td>
                <td>${numberConverter(salaryWithDegree)}</td>
              </tr>
              <tr>
                <td>Est. Salary without Degree:</td>
                <td>${numberConverter(salaryWithoutDegree)}</td>
              </tr>
              {/*<tr>*/}
              {/*<td>Salary Difference after Tax:</td>*/}
              {/*<td>${numberConverter(incremental_diff_dge_no_deg)}</td>*/}
              {/*</tr>*/}
            </tbody>
          </table>
          <br />
          <h6 className="small text-muted" style={{ marginTop: -10 }}>
            Calculation incorporates relevant tax brackets and standard annual
            increases by category.
          </h6>
        </div>
        <div className="col-md-4 p-0 d-none d-lg-block">
          <img
            src={spaceman}
            alt="Trip to Mars"
            style={{ width: '100%', borderRadius: 3 }}
          />
          You could fly to Mars {((breakeven_year * 12) / 7).toFixed(0)} times
          during your payback period!
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/Tuition/components/BreakevenAnalysis.js